import '../main'
import csCheckboxGroup from '../checkbox/src/checkboxGroup.vue'


csCheckboxGroup.install = function (Vue) {
    Vue.component(csCheckboxGroup.name, csCheckboxGroup)
}

export default csCheckboxGroup


// WEBPACK FOOTER //
// ./src/components/checkboxGroup/index.js